const activeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.16154 10.55C3.05385 10.44 3 10.275 3 10.165C3 10.055 3.05385 9.89 3.16154 9.78L3.91538 9.01C4.13077 8.79 4.45385 8.79 4.66923 9.01L4.72308 9.065L7.68462 12.31C7.79231 12.42 7.95385 12.42 8.06154 12.31L15.2769 4.665H15.3308C15.5462 4.445 15.8692 4.445 16.0846 4.665L16.8385 5.435C17.0538 5.655 17.0538 5.985 16.8385 6.205L8.22308 15.335C8.11538 15.445 8.00769 15.5 7.84615 15.5C7.68462 15.5 7.57692 15.445 7.46923 15.335L3.26923 10.715L3.16154 10.55Z"
      fill="#0088FF"
    />
  </svg>
);

const notActiveIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.16154 10.55C3.05385 10.44 3 10.275 3 10.165C3 10.055 3.05385 9.89 3.16154 9.78L3.91538 9.01C4.13077 8.79 4.45385 8.79 4.66923 9.01L4.72308 9.065L7.68462 12.31C7.79231 12.42 7.95385 12.42 8.06154 12.31L15.2769 4.665H15.3308C15.5462 4.445 15.8692 4.445 16.0846 4.665L16.8385 5.435C17.0538 5.655 17.0538 5.985 16.8385 6.205L8.22308 15.335C8.11538 15.445 8.00769 15.5 7.84615 15.5C7.68462 15.5 7.57692 15.445 7.46923 15.335L3.26923 10.715L3.16154 10.55Z"
      fill="#E0E4EC"
    />
  </svg>
);

export { activeIcon, notActiveIcon };